import { Field, TextInput, NumberInput, SectionCard } from "./_shared";

export default function EditStickyCta({ value, onChange }) {
  const set = (k, v) => onChange({ ...value, [k]: v });
  return (
    <SectionCard title="Barra CTA Fixa (aparece ao rolar)">
      <div className="space-y-5">
        <Field label="Texto principal"><TextInput value={value.text} onChange={(v) => set("text", v)} testId="sticky-text-input" /></Field>
        <Field label="Texto do botão"><TextInput value={value.ctaLabel} onChange={(v) => set("ctaLabel", v)} testId="sticky-cta-label-input" /></Field>
        <Field label="Mostrar depois de rolar (em pixels)" hint="Padrão: 800px. Quanto menor, antes ela aparece.">
          <NumberInput value={value.showAfterPx} onChange={(v) => set("showAfterPx", v)} testId="sticky-show-after-input" />
        </Field>
      </div>
    </SectionCard>
  );
}
